export default __webpack_public_path__ + "static/media/img_pst_block_dummy.ee48eda1.png";